import React, { Component } from 'react'
import { Button, Divider, Modal } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


export default class DuplicateOrder extends Component {
    constructor(props) {
        super(props);

        this.state = ({
            modalOpen: false,
            sentOrderNum:this.props.order.order_num
        })
    }

    
    componentDidMount(){
        // console.log("dupx15 +++++++++: componentDidMount");
        // console.log("dupx151 sent order num:"+this.props.order.order_num);
    }

    openModal = () => {
        this.setState({modalOpen:true});
    }

    closeModal = () => {
        this.setState({modalOpen:false});
    }

    getNewOrderNumber = () => {
        console.log("dupx1 +++++++++: getNewOrderNumber")
        //GET NEW ORDER NUMBER
        FbUtils.getOrderNumberAndUpdateCounter(this.createNewOrderObjectAndSave);
    }
  
   

    createNewOrderObjectAndSave = (orderNum) =>{
        console.log("dupx12 +++++++:createNewOrderObjectAndSave");
        console.log("dupx121 orderNum:"+orderNum);
        console.log("dupx123 sentOrderNum:"+this.state.sentOrderNum)

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');

        let tempOrder = this.props.order;
        console.log("dupx13 tempOrder:"+tempOrder.order_num);

        tempOrder.order_num = orderNum;
        tempOrder.duplicatedOrder = true;
        tempOrder.duplicateOf_order = this.state.sentOrderNum;
        tempOrder.duplicateOf_order_key = this.props.orderId;
        tempOrder.enteredBy = this.props.user.email;
        tempOrder.lastUdpatedSecs = new Date().getTime();

        //UPDATE NAME
        tempOrder.name = "**DUPL:"+this.state.sentOrderNum+"**  "+tempOrder.name;
        tempOrder.duplicatedBy = this.props.user.email;

        
        //console.log("new tempOrder:"+JSON.stringify(tempOrder));
        
        //DUPLICATE THE ORDER
        FbUtils.DuplicateOrder(tempOrder);

        //UDPATE OLD ORDER
        let orderUpdate = {
            duplicateOfOrderMade:true,
            duplicateOfOrderMade:now
        }

        FbUtils.updateOrder(this.state.orderId,orderUpdate);
        
        history.push('/dashboard');
    }

    render() {
        return (
            <div>
                <Divider horizontal>{'DUPLICATE THIS ORDER'}</Divider>

                <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
                    <Modal.Header>
                        Duplicate Order
                </Modal.Header>
                    <Modal.Content>
                        <p>Are you sure you want duplicate this order? This will be a separate order</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeModal}>
                            No
                        </Button>
                        <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.getNewOrderNumber} />
                    </Modal.Actions>
                </Modal>

                <Button fluid onClick={this.openModal} color='teal'>DUPLICATE </Button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DuplicateOrder/DuplicateOrder.js